import React, { createContext, useReducer } from "react";
import ActionTypes from "./actionTypes";

export const initialState = {
  Products: [],
  IsLogin: false,
  UserName: "",
  APIVersion: 0,
  BaseURL: "http://api.pigeonconnect.charmedcoder.com/"
  //BaseURL: "http://localhost:64567/",
};

function reducer(state, action) {
  switch (action.actionType) {
    case ActionTypes.LOAD_PRODUCTS:
      return {
        ...state,
        Products: [...new Set(action.payload)],
      };
    case ActionTypes.GET_API_VERSION:
      return {
        ...state,
        APIVersion: action.payload,
      };
    case ActionTypes.RESET_RACE:
      return {
        ...state,
        Race: action.payload,
      };
    case ActionTypes.LOAD_POSTS:
      return {
        ...state,
        Posts: [...new Set(action.payload)],
      };
    case ActionTypes.POPULATE_RACE_FORM:
      return {
        ...state,
        Race: action.payload,
      };
    case ActionTypes.UPDATE_RACE_OBJECT:
      return {
        ...state,
        Race: action.payload,
      };

    case ActionTypes.UPDATE_AUTH_TOKEN:
      return {
        ...state,
        AuthToken: action.payload,
      };
    case ActionTypes.UPDATE_LOGIN:
      return {
        ...state,
        IsLogin: action.payload,
      };
    case ActionTypes.UPDATE_USERNAME:
      return {
        ...state,
        UserName: action.payload,
      };
  }
}

export const StoreContext = createContext({
  ...initialState,
  dispatch: undefined,
});

const StoreProvider = ({ children }) => {
  const [state, dispatch] = useReducer(reducer, initialState);

  return (
    <StoreContext.Provider value={{ ...state, dispatch: dispatch }}>
      {children}
    </StoreContext.Provider>
  );
};

export default StoreProvider;
